import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import getParamsForExtraInfo from './getParamsForExtraInfo';

/**
 *
 * @param {Object} win
 * @param {HTMLFormElement} form
 * @param {Object} prefParams
 */
const injectExtraInfoParams = (win, form, prefParams, isSubmission = false) => {
	const paramNames = getParamsForExtraInfo(win, prefParams);
	const params = {};
	paramNames.forEach((paramName) => {
		const paramValue = win.sessionStorage.getItem(
			`extra-info-param-${paramName}`
		);

		// We inject the param if it exists
		if (paramValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${paramName.toUpperCase()}=1=${paramName}`,
				paramValue
			);
			params[paramName] = paramValue;
		}
	});
	window?.newrelic?.addPageAction('utm_url_params_injected', {
		source: 'ws-tracking',
		eventName: 'utm_url_params_injected',
		paramsForExtraInfo: params,
		why: 'paramsForExtraInfo pref',
		isSubmission
	});
};
export default injectExtraInfoParams;
